import { signal } from '@preact/signals-react';

import { Chatbot } from '@/services/hubbot/types';

export const chatbots = signal<Chatbot[]>([]);
